module.exports = __webpack_public_path__ + "videos/Gritify_Company_en.1e84f21.mp4";